import { io } from 'socket.io-client';
import {
  CLOSE_SOCKET_DISCONNECTING_EVENT,
  OBTAIN_TOKEN_EVENT,
  RECONNECT_SOCKET_EVENT,
  SHOW_SOCKET_DISCONNECTING_EVENT,
  EMIT_JOIN_SOCKET_EVENT,
  HIDE_DISCONNECTED_MODAL_EVENT,
  NETWORK_SETTINGS
} from '@/core/values/app.values';
import { AppStore } from '@/core/store/app.store';
import BrowserService from '@/providers/browser-utils/browser.service';

export const EdSocket = {
  install: (Vue) => {
    Vue.prototype.$EdSocket = new Vue({
      data() {
        return { client: null }
      },
      methods: {
        connect(userName: string, token: string, socketUrl : string): Promise<void> {
          return new Promise((resolve, reject) => {
            const device = BrowserService.getFullBrowserInfo();
            this.client = io(socketUrl, {
              query: {
                userName,
                device
              }, 
              auth: {
                token
              }, 
              ...NETWORK_SETTINGS.socketIo.connection,
              transports: ['websocket']
            });

            this.client.on('connect', () => {
              /*if(AppStore.state.isPreviousDisconnectionSocket){
                this.connectManually();
                return resolve();
              }*/
              
              if(AppStore.state.isPreviousDisconnectionSocket){
                this.$edEventBus.$emit(RECONNECT_SOCKET_EVENT);
              }
              
              this.$edEventBus.$emit(EMIT_JOIN_SOCKET_EVENT);
              this.$edEventBus.$emit(CLOSE_SOCKET_DISCONNECTING_EVENT);

              resolve();
            });

            this.client.on('connect_error', (error : Error) => {
              this.$edEventBus.$emit(SHOW_SOCKET_DISCONNECTING_EVENT, {isBoard: false});
              if(error.message === 'Invalid token'){
                this.$edEventBus.$emit(OBTAIN_TOKEN_EVENT, true);
              }
              reject(error);
            });

            this.client.on('disconnect', (reason) => {
              this.$edEventBus.$emit(SHOW_SOCKET_DISCONNECTING_EVENT, {isBoard: false});
            });
          });
        },
        on(eventName: string, cbSuccess: Function, cbError = (value) => {}) {
          this.client.on(eventName, (payload : any) => {
            try{
              cbSuccess(payload);
            } catch(error) {
              cbError(error);
            }
          });
        },
        off(eventName: string) {
          if(eventName) this.client.removeAllListeners(eventName);
        },
        emit(eventName: string, data: any, callback: Function = null) {
          if(!(this.client && this.client.connected)){
            return;
          }
          return this.client.emit(eventName, data, callback);
        },
        connectManually(token: string) {
          this.client.auth.token = token;
          this.client.connect();

        },
        validateExistsListener(eventName: string) {
          return this.client.listeners(eventName).length > 0;
        },
        disconnectManually() {
          this.client.disconnect();
          this.$edEventBus.$emit(HIDE_DISCONNECTED_MODAL_EVENT);
        }
      }
    });
  }
}
